export const SET_TEAMS = "setTeams";
export const CLEAR_TEAMS = "clearTeams";
export const SET_TEAMS_TREE = "setTeamsTree";
export const CLEAR_TEAMS_TREE = "clearTeamsTree";
export const SET_TEAM = "setTeam";
export const CLEAR_TEAM = "clearTeam";
export const SET_PARENT = "setParent";
export const SET_NAME = "setName";
export const SET_COLOR = "setColor";
export const SET_PERMISSION_DISABLED = "setPermissionDisabled";
export const SET_PERMISSION = "setPermission";
export const ADD_PERMISSION = "addPermission";
export const ADD_MEMBER = "addMember";
export const REMOVE_MEMBER = "removeMember";
